import React from 'react'
import Header from './partials/Header';
import Footer from './partials/Footer';
import { Outlet } from 'react-router-dom';

export default function BasePageLayout() {
    return (<site-wrapper>
        <Header />
        <main className="main-content" role="main">
            <Outlet />
        </main>
        <Footer />
    </site-wrapper>)
}
